import { Skeleton } from 'shared/ui/skeleton'

const CloseCircleSkeleton = () => {
  return (
    <Skeleton
      width={'100%'}
      height={40}
      borderRadius={16}
    />
  )
}

export default CloseCircleSkeleton
